// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import classNames from 'classnames'
import { gql } from 'graphql-tag'
import omit from 'lodash/omit'
import moment from 'moment'
import React from 'react'
import { Mutation } from 'react-apollo'
import CheckBox from '../../common/checkBox/CheckBox'
import withConfirmModal from '../../common/confirmModal/withConfirmModal'
import Select from '../../common/select/Select'
import Textarea from '../../common/textarea/Textarea'
import TextField from '../../common/textField/TextField'
import TimeField from '../../common/timeField/TimeField'
import { i18n } from '../index'
import css from './dailyInfoReservationsTable.css'
import { ReservationType, type MealOption, type Reservation } from './data'
const CREATE_RESERVATION_MUTATION = gql`
  mutation CreateReservation($stationId: ID!, $data: CreateReservationInputType!) {
    createReservation(stationId: $stationId, data: $data) {
      startTime
      endTime
      name
      peopleCount
      otherInfo
      room
      contactName
      contactPhone
      paymentMethod
      reservationType
      mealOptionId
      mealOptionDescription
    }
  }
`
const UPDATE_RESERVATION_MUTATION = gql`
  mutation UpdateReservation($id: ID!, $data: UpdateReservationInputType!) {
    updateReservation(reservationId: $id, data: $data) {
      startTime
      endTime
      name
      peopleCount
      otherInfo
      room
      contactName
      contactPhone
      paymentMethod
      reservationType
      mealOptionId
      mealOptionDescription
    }
  }
`
const DELETE_RESERVATION_MUTATION = gql`
  mutation DeleteReservation($id: ID!) {
    deleteReservation(reservationId: $id) {
      Success
    }
  }
`
type Props = {
  edit: boolean
  items: Array<Reservation>
  stationId: string
  date: string
  confirmModal: {
    show: (...args: Array<any>) => any
  }
  mealOptions: MealOption[]
}
type FormData = {
  id: string | null | undefined
  name: string
  startTime: string
  endTime: string
  peopleCount: number
  otherInfo: string
  room: string
  contactName: string
  contactPhone: string
  paymentMethod: string
  reservationType: string
  mealOptionId: number | null
}
type State = {
  formData: FormData
}

function mealOptionToSelectOption(mealOption: MealOption): { value: number; label: string } {
  const label = mealOption.description ? `${mealOption.name}: ${mealOption.description}` : mealOption.name
  return {
    value: mealOption.id,
    label,
  }
}

class DailyInfoReservationsTable extends React.Component<Props, State> {
  state: State = {
    formData: {
      id: null,
      name: '',
      startTime: moment().format('HH:mm'),
      endTime: '',
      peopleCount: 1,
      otherInfo: '',
      room: '',
      contactName: '',
      contactPhone: '',
      paymentMethod: '',
      reservationType: 'none',
      mealOptionId: null,
      mealOptionDescription: '',
    },
  }
  componentDidMount = () => {
    this.onReset()
  }
  setFieldValue = (field: string, value: any) => {
    this.setState({
      formData: { ...this.state.formData, [field]: value },
    })
  }
  getFieldValue = (field: string) => {
    return this.state.formData[field]
  }
  isValid = () => {
    const { formData } = this.state
    return Number(formData.peopleCount) && formData.name && formData.startTime
  }
  onDelete = (mutation: (...args: Array<any>) => any, reservation: Reservation) => {
    this.props.confirmModal.show(i18n.t('dailyInfo.reservationsTable.deleteConfirmText'), (isConfirmed: boolean) => {
      if (isConfirmed) {
        mutation({
          variables: {
            id: reservation.id,
          },
        })
      }
    })
  }
  onReset = () => {
    const { mealOptions } = this.props
    this.setState({
      formData: {
        id: null,
        name: '',
        startTime: moment().format('HH:mm'),
        endTime: '',
        peopleCount: 1,
        otherInfo: '',
        reservationType: 'none',
        mealOptionId: null,
        mealOptionDescription: '',
      },
    })
  }
  onCompleted = () => {
    this.onReset()
  }
  onSubmit = (e: any, mutation: (...args: Array<any>) => any) => {
    e.preventDefault()
    const { stationId, date } = this.props
    const { formData } = this.state

    if (!this.isValid()) {
      return
    }

    const variables: State['formData'] = {
      data: {
        ...omit(formData, ['id']),
        peopleCount: +formData.peopleCount,
        mealOptionId: +formData.mealOptionId,
        startTime: moment(`${date} ${formData.startTime}`).toISOString(),
      },
    }

    if (formData.id) {
      variables.id = formData.id
    } else {
      variables.stationId = stationId
    }

    mutation({
      variables: variables,
    })
  }
  onEdit = (reservation: Reservation) => {
    this.setState({
      formData: {
        id: reservation.id,
        name: reservation.name,
        peopleCount: reservation.peopleCount,
        otherInfo: reservation.otherInfo,
        startTime: moment(reservation.startTime).format('HH:mm'),
        endTime: reservation.endTime,
        room: reservation.room,
        contactName: reservation.contactName,
        contactPhone: reservation.contactPhone,
        paymentMethod: reservation.paymentMethod,
        reservationType: reservation.reservationType,
        mealOptionId: reservation.mealOptionId ? String(reservation.mealOptionId) : null,
        mealOptionDescription: reservation.mealOptionDescription ?? '',
      },
    })
  }
  renderForm = () => {
    const id = this.getFieldValue('id')
    const { mealOptions } = this.props

    const saveButtonDisabled = this.getFieldValue('reservationType') === '' && !this.getFieldValue('mealOptionId')

    return (
      <Mutation
        mutation={CREATE_RESERVATION_MUTATION}
        refetchQueries={() => ['DailyInfoQuery', 'CustomerTargetBarQuery']}
        onCompleted={this.onCompleted}
      >
        {(createMutation) => (
          <Mutation
            mutation={UPDATE_RESERVATION_MUTATION}
            refetchQueries={() => ['DailyInfoQuery', 'CustomerTargetBarQuery']}
            onCompleted={this.onCompleted}
          >
            {(updateMutation) => (
              <form className={css.form} onSubmit={(e) => this.onSubmit(e, id ? updateMutation : createMutation)}>
                <div className={css.row}>
                  <div className={css.column}>
                    <TextField
                      className={css.groupName}
                      label={i18n.t('dailyInfo.reservationsTable.groupNameLabel')}
                      placeholder={i18n.t('dailyInfo.reservationsTable.groupNamePlaceholder')}
                      value={this.getFieldValue('name')}
                      onChange={(e) => this.setFieldValue('name', e.target.value)}
                    />
                    <div className={classNames(css.row, css.alignStart)}>
                      <TextField
                        className={css.reservationInput}
                        label={i18n.t('dailyInfo.reservationsTable.roomlabel')}
                        placeholder={i18n.t('dailyInfo.reservationsTable.roomlabel')}
                        value={this.getFieldValue('room') || ''}
                        onChange={(e) => this.setFieldValue('room', e.target.value)}
                      />
                      <TextField
                        className={css.reservationInput}
                        label={i18n.t('dailyInfo.reservationsTable.groupSizeLabel')}
                        value={this.getFieldValue('peopleCount')}
                        onChange={(e) => this.setFieldValue('peopleCount', e.target.value)}
                      />
                    </div>
                    <div className={classNames(css.row, css.alignStart)}>
                      <TimeField
                        className={css.reservationInput}
                        label={i18n.t('dailyInfo.reservationsTable.startTimeLabel')}
                        placeholder={i18n.t('dailyInfo.reservationsTable.startTimeLabel')}
                        value={this.getFieldValue('startTime')}
                        onChange={(_, value) => this.setFieldValue('startTime', value)}
                      />
                      <TextField
                        className={css.reservationInput}
                        label={i18n.t('dailyInfo.reservationsTable.endTimeLabel')}
                        placeholder={'HH:MM'}
                        value={this.getFieldValue('endTime')}
                        onChange={(e) => this.setFieldValue('endTime', e.target.value)}
                      />
                    </div>
                    <Grid direction='column' spacing={2} container>
                      <Grid direction='column' justifyContent='space-between' container>
                        <Grid>
                          <CheckBox
                            label={i18n.t('dailyInfo.reservationsTable.buffetTypeLabel')}
                            checked={this.getFieldValue('reservationType') === ReservationType.Buffet}
                            onChange={(e) =>
                              this.setFieldValue('reservationType', e.target.checked ? ReservationType.Buffet : 'none')
                            }
                          />
                        </Grid>
                        <Grid>
                          <CheckBox
                            label={i18n.t('dailyInfo.reservationsTable.pizzaTableTypeLabel')}
                            checked={this.getFieldValue('reservationType') === ReservationType.PizzaTable}
                            onChange={(e) =>
                              this.setFieldValue(
                                'reservationType',
                                e.target.checked ? ReservationType.PizzaTable : 'none',
                              )
                            }
                          />
                        </Grid>
                        <Grid>
                          <CheckBox
                            label={i18n.t('dailyInfo.reservationsTable.buffetWorldTypeLabel')}
                            checked={this.getFieldValue('reservationType') === ReservationType.BuffetWorld}
                            onChange={(e) =>
                              this.setFieldValue(
                                'reservationType',
                                e.target.checked ? ReservationType.BuffetWorld : 'none',
                              )
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid direction='row' justifyContent='space-between' container>
                        <Grid>
                          <CheckBox
                            label={i18n.t('dailyInfo.reservationsTable.otherTypeLabel')}
                            checked={this.getFieldValue('reservationType') === ReservationType.GroupDiningOther}
                            onChange={(e) =>
                              this.setFieldValue(
                                'reservationType',
                                e.target.checked ? ReservationType.GroupDiningOther : 'none',
                              )
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <div className={css.row}>
                      {this.state.formData.reservationType === ReservationType.GroupDiningOther && (
                        <Select
                          className={css.reservationInput}
                          label={i18n.t('dailyInfo.reservationsTable.mealOption')}
                          value={this.getFieldValue('mealOptionId')}
                          options={mealOptions.map(mealOptionToSelectOption)}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              formData: {
                                ...this.state.formData,
                                mealOptionId: e.value,
                                mealOptionDescription: e.label,
                              },
                            })
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className={css.column}>
                    <div className={css.row}>
                      <TextField
                        className={css.contactName}
                        label={i18n.t('dailyInfo.reservationsTable.contactNameLabel')}
                        placeholder={i18n.t('dailyInfo.reservationsTable.contactNameLabel')}
                        value={this.getFieldValue('contactName') || ''}
                        onChange={(e) => this.setFieldValue('contactName', e.target.value)}
                      />
                      <TextField
                        className={css.contactPhone}
                        label={i18n.t('dailyInfo.reservationsTable.contactPhoneLabel')}
                        placeholder={i18n.t('dailyInfo.reservationsTable.contactPhoneLabel')}
                        value={this.getFieldValue('contactPhone') || ''}
                        onChange={(e) => this.setFieldValue('contactPhone', e.target.value)}
                      />
                      <TextField
                        className={css.paymentMethod}
                        label={i18n.t('dailyInfo.reservationsTable.paymentMethodLabel')}
                        placeholder={i18n.t('dailyInfo.reservationsTable.paymentMethodLabel')}
                        value={this.getFieldValue('paymentMethod') || ''}
                        onChange={(e) => this.setFieldValue('paymentMethod', e.target.value)}
                      />
                    </div>
                    <Textarea
                      className={css.description}
                      label={i18n.t('dailyInfo.reservationsTable.descriptionLabel')}
                      placeholder={i18n.t('dailyInfo.reservationsTable.descriptionPlaceholder')}
                      value={this.getFieldValue('otherInfo')}
                      onChange={(e) => this.setFieldValue('otherInfo', e.target.value)}
                      rows={5}
                    />
                    <div>
                      {this.getFieldValue('mealOptionDescription') && (
                        <Paper>
                          <Typography>{this.getFieldValue('mealOptionDescription')}</Typography>
                        </Paper>
                      )}
                    </div>
                  </div>
                </div>
                <div className={css.formActions}>
                  <Button variant='contained' onClick={this.onReset}>
                    {i18n.t('buttons.cancel')}
                  </Button>
                  <Button type='input' variant='contained' color='primary' disabled={saveButtonDisabled}>
                    {id
                      ? i18n.t('dailyInfo.reservationsTable.saveButtonText')
                      : i18n.t('dailyInfo.reservationsTable.addButtonText')}
                  </Button>
                </div>
              </form>
            )}
          </Mutation>
        )}
      </Mutation>
    )
  }
  renderItems = () => {
    const { items, edit } = this.props
    const colSpan = edit ? 10 : 8

    if (!items.length) {
      return (
        <tr>
          <td colSpan={colSpan}>{i18n.t('dailyInfo.reservationsTable.emptyText')}</td>
        </tr>
      )
    }

    return items.map((item, i) => {
      return (
        <tr key={i}>
          <td>{moment(new Date(item.startTime)).format('dd')}</td>
          <td>{moment(new Date(item.startTime)).format('D.M.YYYY')}</td>
          <td>{moment(new Date(item.startTime)).format('HH:mm')}</td>
          <td>{item.endTime || '-'}</td>
          <td>{item.room}</td>
          <td>{item.name}</td>
          <td>{item.peopleCount}</td>
          <td>{item.otherInfo}</td>
          {edit && (
            <React.Fragment>
              <td>
                <a className={classNames(css.action, css.checkedButton)} onClick={() => this.onEdit(item)}>
                  <EditIcon />
                </a>
              </td>
              <td>
                <Mutation mutation={DELETE_RESERVATION_MUTATION} refetchQueries={() => ['DailyInfoQuery']}>
                  {(mutation) => (
                    <a
                      className={classNames(css.action, css.checkedButton)}
                      onClick={() => this.onDelete(mutation, item)}
                    >
                      <DeleteIcon />
                    </a>
                  )}
                </Mutation>
              </td>
            </React.Fragment>
          )}
        </tr>
      )
    })
  }

  render() {
    const { edit } = this.props
    return (
      <div className={css.component}>
        {edit && this.renderForm()}
        <h4>{i18n.t('dailyInfo.reservationsTable.tableTitle')}</h4>

        <table className={css.table}>
          <thead>
            <tr>
              <th>{i18n.t('dailyInfo.reservationsTable.dayOfWeek')}</th>
              <th>{i18n.t('dailyInfo.reservationsTable.date')}</th>
              <th>{i18n.t('dailyInfo.reservationsTable.startTimeTableHeader')}</th>
              <th>{i18n.t('dailyInfo.reservationsTable.endTimeTableHeader')}</th>
              <th>{i18n.t('dailyInfo.reservationsTable.roomTableHeader')}</th>
              <th>{i18n.t('dailyInfo.reservationsTable.groupNameTableHeader')}</th>
              <th>{i18n.t('dailyInfo.reservationsTable.groupSizeTableHeader')}</th>
              <th>{i18n.t('dailyInfo.reservationsTable.descriptionTableHeader')}</th>
              {edit && (
                <React.Fragment>
                  <th className={css.actionHeader}>{i18n.t('dailyInfo.reservationsTable.editTableHeader')}</th>
                  <th className={css.actionHeader}>{i18n.t('dailyInfo.reservationsTable.deleteTableHeader')}</th>
                </React.Fragment>
              )}
            </tr>
          </thead>
          <tbody>{this.renderItems()}</tbody>
        </table>
      </div>
    )
  }
}

export default withConfirmModal(DailyInfoReservationsTable)
